import { useEffect, useState } from "react";
import { api, type Book, type Page as PageData } from "../api";
import { BookView } from "../components/book";
import { StaticBookIllustration } from "../components/StaticBookIllustration";

type DemoState =
  | { kind: "loading" }
  | { kind: "fallback" }
  | { kind: "book"; book: Book; pages: PageData[] };

/** Decorative sample-book illustration for the landing hero. Fetches a live
 *  demo book and falls back to the static illustration when none is available. */
export default function LandingDemo() {
  const [state, setState] = useState<DemoState>({ kind: "loading" });

  useEffect(() => {
    let alive = true;
    void api
      .getDemo()
      .then((r) => {
        if (!alive) return;
        if (r && r.pages.length > 0) setState({ kind: "book", book: r.book, pages: r.pages });
        else setState({ kind: "fallback" });
      })
      .catch(() => { if (alive) setState({ kind: "fallback" }); });
    return () => { alive = false; };
  }, []);

  // Loading and fallback both render the static illustration so the hero is
  // never broken or empty.
  if (state.kind !== "book") return <StaticBookIllustration />;
  return <BookView book={state.book} pages={state.pages} startAtFirstPage />;
}
